import React, {useState, useMemo, useEffect, useContext} from 'react';
import styled from 'styled-components';

import Pagination from 'components/pagination';
import SearchSort from 'components/pages/search/searchSort';

import theme, {bp, color} from 'settings/theme';

import {SearchContext} from 'services/searchService';


type Props = {};


// Component
const Component: React.FC<Props> = (props) => {

  const search = useContext(SearchContext);

  return (
    <StyledComponent className="searchLargeToolbar">

      <div className="searchLargeToolbar-count">
        {!search.isLoading &&
          <div>
            <strong>{search.meta?.totalHits}&nbsp;</strong>Products Found
          </div>
        }
      </div>

      <div className="searchLargeToolbar-sort">
        <SearchSort />
      </div>

      <div className="searchLargeToolbar-pagination">
        <Pagination 
          size="small"
          totalCount={search.meta?.totalHits ?? 0} 
          itemsPerPage={search.meta?.hitsPerPage}
          currentPage={search.meta?.page ?? 1}
          pagesToShow={5}
          showDirectionButtons={true}
          showLimitButtons={true}
          urlMode="query"
        ></Pagination>
      </div>

    </StyledComponent>
  ) ;

}


export default Component;




// Styles
const StyledComponent = styled.div`

  z-index: 1;
  display: none;
  width: 100%;
  height: 60px;
  font-family: ${theme.typography.fontFamilySecondary};
  color: ${color.grey(40)};
  border-bottom: solid 1px ${color.lines};
  background-color: white;

  .searchLargeToolbar-count{
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 18px;
    border-right: solid 1px ${color.lines};
  }


  .searchLargeToolbar-sort{
    display: none;
    border-right: solid 1px ${color.lines};
  }



  .searchLargeToolbar-pagination{

    display: flex;
    align-items: center;
    flex: 0 0 auto;
    padding-left: 18px;
    padding-right: 18px;

    button{

      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding-left: 12px;
      padding-right: 12px;
      transition: all 0.15s ease-out;

      &:hover, &:focus{
        background-color: ${color.pageBackground};
      }

    }

    .searchLargeToolbar-pagination-icon{

      margin-right: 8px;

      .icon{

        width: 14px;
        height: 14px;

        svg{
          fill:${color.grey(20)};
        }

      }

    }

    .searchLargeToolbar-pagination-text{
      position: relative;
      top: 1px;
    }

  }



  @media (min-width: ${bp(3)}) {
    display: flex;
    height: 60px;
  }


  @media (min-width: ${bp(4)}) {

    position: sticky;
    top: 140px;

    .searchLargeToolbar-sort{
      display: flex;
    }
      
  }


  @media (min-width: ${bp(5)}) {

    .searchLargeToolbar-count{
      padding-left: 50px;
      padding-right: 50px;
    }

  }


`;



